import { Stack, Text, TableRow, TableCell } from 'braid-design-system';
import type { GraphQLType, OperationTypeNode } from 'graphql';

import { NameTextLink } from '#src/components/NameTextLink/NameTextLink.tsx';
import { TypeLink } from '#src/components/TypeLink/TypeLink.tsx';
import { hrefForOperationArgument } from '#src/utils/href.ts';

import { SchemaMarkdown } from './SchemaMarkdown.tsx';

interface ArgPathProps {
  operationType: OperationTypeNode;
  operationName: string;
  argName: string;
}

interface Props extends ArgPathProps {
  arg: string;
  type: GraphQLType;
  highlight?: boolean;
  deprecated: boolean;
}

export const ArgDetails = ({
  arg,
  operationType,
  operationName,

  argName,
  type,
  highlight,
  deprecated,
}: Props) => {
  const hrefLinkTo = hrefForOperationArgument(
    operationType,
    operationName,
    argName,
  );
  const elementIdLinkTo = `${operationName}-${argName}`;
  return (
    <TableRow>
      <TableCell width="content">
        <Stack space="medium">
          <NameTextLink
            name={argName}
            type={type}
            highlight={highlight}
            to={hrefLinkTo}
            id={elementIdLinkTo}
            deprecated={deprecated}
          />
          <Text>
            <TypeLink type={type} />
          </Text>
        </Stack>
      </TableCell>

      <TableCell wrap>
        <SchemaMarkdown type={arg} />
      </TableCell>
    </TableRow>
  );
};
